import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'stringFormat',
    standalone: false
})
export class StringFormat implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(str: string, args: string[]){
    return this.getString(str).replace(/{(\d+)}/g, (match, index) => args[index] != null ? args[index] : '');
  }

  getString(value: string): string {
    let str: string = '';

    if (value != undefined && value != '') {
      this.translate.get(value).subscribe((res: string) => {
        return (str = res);
      });
    }

    return str;
  }
}
